import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '*',      //404页面 - 匹配所有未定义的路由
    component: () => import('../views/404.vue')
  },
  {
    path: '/login',     //用户登录
    name: 'login',
    component: () => import('../views/user/login.vue')
  },
  {
    path: '/logout',     //用户退出
    name: 'logout',
    component: () => import('../views/user/logout.vue')
  },
  {
    path: '/reg',     //用户注册
    component: () => import('../views/user/reg.vue')
  },
  {
    path: '/pwd',     //密码找回
    component: () => import('../views/user/pwd.vue')
  },
  {
    path: '/',      //根路由
    name: 'home',
    redirect: '/index',   //跳转到
    component: () => import('../views/Home.vue'),
    children: [
      {
        path: '/index',     //首页
        name: 'index',
        component: () => import('../views/index/Index.vue')
      },
      {
        path: '/myinfo',    //修改个人信息
        component: () => import('../views/user/myInfo.vue')
      },
      // -------------  超级管理员部分 - 开始  ----------------
      {
        path: '/roles',     //角色管理
        component: () => import('../views/supadmin/roles/index.vue')
      },
      {
        path: '/users',     //用户管理
        component: () => import('../views/supadmin/users/index.vue')
      },
      {
        path: '/menus',     //菜单管理
        component: () => import('../views/supadmin/menus/index.vue')
      },
      {
        path: '/logs',     //日志管理
        component: () => import('../views/supadmin/logs/index.vue')
      },
      {
        path: '/configs',     //参数设置
        component: () => import('../views/supadmin/configs/index.vue')
      },
      // -------------  超级管理员部分 - 结束  ----------------
      // 
      // -------------  应用管理员部分 - 开始  ----------------
      {
        path: '/usersadmin',     //用户管理
        component: () => import('../views/admin/users/index.vue')
      },
      {
        path: '/leibie',     //产品类别管理
        component: () => import('../views/admin/leibie/index.vue')
      },
      {
        path: '/product',     //产品管理
        component: () => import('../views/admin/product/index.vue')
      },
      {
        path: '/picis',     //批次管理
        component: () => import('../views/admin/picis/index.vue')
      },
      {
        path: '/jilus',     //农事管理
        component: () => import('../views/admin/jilus/index.vue')
      },
      {
        path: '/hgzs',     //证码管理
        component: () => import('../views/admin/hgzs/index.vue')
      },
      {
        path: '/fazheng',     //发证管理
        component: () => import('../views/admin/fazheng/index.vue')
      },
      {
        path: '/ratings',     //评价管理
        component: () => import('../views/admin/rating/index.vue')
      },
      {
        path: '/counts',     //数据统计
        component: () => import('../views/admin/counts/index.vue')
      },
      {
        path: '/tomap',     //数据统计
        component: () => import('../views/main/map.vue')
      },
      // -------------  应用管理员部分 - 结束  ----------------
      // 
      // -------------  应用部分 - 开始  ----------------
      {
        path: '/pici',     //批次管理
        component: () => import('../views/main/pici/index.vue')
      },
      {
        path: '/jilu',     //操作记录
        component: () => import('../views/main/jilu/index.vue')
      },
      {
        path: '/hgz',     //合格证管理
        component: () => import('../views/main/hgz/index.vue')
      },
      {
        path: '/rating',     //评价管理
        component: () => import('../views/main/rating/index.vue')
      },
      // -------------  应用部分 - 结束  ----------------
    ]
  },
  // 应用内容定义部分
  {
    path: '/c/:ewmstr/:type?',       //合格证查验
    component: () => import('../views/main/chayan.vue'),
    meta: {
      title: '承诺达标合格证',
      // keepAlive: true,    //需要被缓存
    },
  },
  {
    path: '/map',       //农资一张图
    component: () => import('../views/main/map.vue'),
    meta: {
      title: '农业投入品一张图',
      // keepAlive: true,    //需要被缓存
    },
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
